/**
 * Provides data for `PageAddedEventHandler` event.
 * This event raises when adding the new PDF page to the PDF document.
 */
var PageAddedEventArgs = /** @class */ (function () {
    function PageAddedEventArgs(page) {
        if (typeof page !== 'undefined') {
            this.pdfPage = page;
        }
        else {
            this.pdfPage = null;
        }
    }
    Object.defineProperty(PageAddedEventArgs.prototype, "page", {
        /**
         * Gets the `newly added page`.
         * @private
         */
        get: function () {
            return this.pdfPage;
        },
        enumerable: true,
        configurable: true
    });
    return PageAddedEventArgs;
}());
export { PageAddedEventArgs };



//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/node_modules/@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-pdf-export/src/implementation/pages/page-added-event-arguments.js
// module id = ../../../../@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-pdf-export/src/implementation/pages/page-added-event-arguments.js
// module chunks = vendor